import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Youtube as YoutubeIcon, Play, ExternalLink } from 'lucide-react';

const YouTube = () => {
  const videos = [
    {
      title: "Huslån - tjen penge på dit huslån",
      url: "https://www.youtube.com/watch?v=QfJYNmjL6ag",
      embedUrl: "https://www.youtube.com/embed/QfJYNmjL6ag?si=PZWVX9NNeUu_3uAj",
      thumbnail: "https://assets.auxodev.dk/assets/3ae65674-a84a-41bf-9a95-918b20317861/feb13f64-f5fd-4572-a17f-6358144b9082.jpg"
    },
    {
      title: "Finansoptimering - Uvildig økonomisk rådgivning for private og erhvervsdrivende",
      url: "https://youtu.be/p0nEUzGEaoY?si=ZaG4nTfqDpPMNhhC",
      embedUrl: "https://www.youtube.com/embed/p0nEUzGEaoY?si=JzeB3wa0AWUb8azK",
      thumbnail: "https://assets.auxodev.dk/assets/3ae65674-a84a-41bf-9a95-918b20317861/feb13f64-f5fd-4572-a17f-6358144b9082.jpg"
    }
  ];

  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>YouTube: Økonomisk rådgivning på YouTube</title>
        <meta name="description" content="Få gratis råd til din økonomi af Finansoptimering ved at følge vores YouTube-kanal. Vi viser også filmene på hjemmesiden. Se mere her" />
      </Helmet>

      <div className="container mx-auto px-4 max-w-5xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-[#b60f00]">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">YouTube</span>
        </nav>

        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6 break-words">Finansoptimering på YouTube</h1>
        
        <div className="prose prose-slate prose-lg max-w-none mb-12">
          <p>
            Finansoptimering kan findes på YouTube! Følg med på vores kanal <a href="http://www.youtube.com/c/FinansoptimeringDK" target="_blank" rel="noopener noreferrer" className="text-[#b60f00] hover:underline">her</a>, eller se vores videoer herunder og få tips og tricks til din økonomi. Du kan også blive abonnent på vores Youtube kanal og blive informeret via e-mail, så snart vi lægger nye videoer og opdateringer på kanalen. For at blive abonnent skal du blot besøge vores Youtube kanal. Her kan du vælge “abonner”. Vær opmærksom på, at du skal være logget ind med din Google Konto for at kunne abonnere.
          </p>
          
          <div className="bg-red-50 p-6 rounded-2xl border border-red-100 my-8">
            <h3 className="text-xl font-bold text-slate-900 mb-2">Har du forslag til økonomiske emner?</h3>
            <p className="text-slate-700">
              Har du et økonomisk spørgsmål, som du kunne tænke dig, at vi gik i dybden med, så kontakt os på <a href="mailto:info@finansoptimering.dk" className="text-[#b60f00] hover:underline">info@finansoptimering.dk</a>.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {videos.map((video, index) => (
            <div key={index} className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 leading-tight h-14 flex items-end">
                {video.title}
              </h2>
              <div className="relative group rounded-3xl overflow-hidden shadow-lg aspect-video bg-slate-900">
                {video.embedUrl ? (
                  <iframe
                    width="100%"
                    height="100%"
                    src={video.embedUrl}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    className="w-full h-full"
                  ></iframe>
                ) : (
                  <>
                    <img 
                      src={video.thumbnail} 
                      alt={video.title} 
                      className="w-full h-full object-cover opacity-70 group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <a 
                        href={video.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center hover:bg-red-700 transition-all hover:scale-110 shadow-xl"
                      >
                        <Play size={24} fill="currentColor" />
                      </a>
                    </div>
                    <div className="absolute bottom-4 right-4">
                      <a 
                        href={video.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="bg-white/90 backdrop-blur-sm text-slate-900 p-2 rounded-lg hover:bg-white transition-colors"
                      >
                        <ExternalLink size={18} />
                      </a>
                    </div>
                  </>
                )}
              </div>
              <div className="flex items-center justify-between text-sm text-slate-500 px-2">
                <span className="flex items-center">
                  <YoutubeIcon size={16} className="mr-1 text-red-600" />
                  Finansoptimering ApS
                </span>
                <a href={video.url} target="_blank" rel="noopener noreferrer" className="text-[#b60f00] font-semibold hover:underline">
                  Se på YouTube
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <a 
            href="http://www.youtube.com/c/FinansoptimeringDK" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center bg-red-600 text-white px-10 py-5 rounded-2xl text-lg font-bold hover:bg-red-700 transition-all shadow-lg active:scale-95"
          >
            <YoutubeIcon size={24} className="mr-3" />
            Besøg vores YouTube kanal her
          </a>
        </div>
      </div>
    </div>
  );
};

export default YouTube;
